<template>
  <div>
    <template v-if="galleries.length > 0">
      <div v-for="gallery in galleries" :key="gallery.id">
        <Gallery :gallery-type="galleryType" :gallery="gallery" />
      </div>
    </template>
    <template v-else>
      <div v-if="!isTaggingCompleted">
          <CtaSupport :event-name="eventName" :pica-code="picaCode" v-if="isPromo"/>
          <CtaNoPhotosBought :event-name="eventName" :pica-code="picaCode" v-else/>
        </div>
    </template>
  </div>
</template>


<script>

import Gallery from "@/domain/galleries/Gallery.vue";
import CtaSupport from "@/domain/checkinDetail/cta/CtaSupport.vue";
import CtaNoPhotosBought from "@/domain/checkinDetail/cta/CtaNoPhotosBought.vue";
import {mapGetters} from "vuex";

export default {
  name: 'UnlockedGalleries',
  components: {CtaNoPhotosBought, CtaSupport, Gallery},
  props: {
    galleries: {
      type: Array,
      required: true
    },
    galleryType: {
      type: String,
      required: true
    }
  },
    computed: {
    ...mapGetters('checkinDetail', [
      'eventName',
      'picaCode',
      'isPromo',
      'isTaggingCompleted',]),
  },
}
</script>
